// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__ehJRN","carousel":"styles_carousel__xw_hN"};